import {UrlAndSecret} from "src/pages/AdminPage/AddAndUpdateSaas/dialogs/generic/UrlAndSecret/UrlAndSecret";

export const BambooHR = () => {

  return <UrlAndSecret
    urlLabel="Your BambooHR subdomain"
    secretLabel="Your BambooHR API Key"
  />
 };
